import { Outlet, useLocation, useNavigate } from "react-router-dom";
import triangleIcon from '../../Assets/images/icons/triangle-left.svg';
import { Utils } from "../../Utils";
import { FiSearch } from "react-icons/fi";
import { useEffect, useState } from "react";
import { getItem } from "../../Services/localService";
// '../../Assets/images/icons/triangle-left.svg';

const Setup = ({ setShowNav }) => {
    let userPermissionData = getItem('userPermission')?.adminLevel;
    let currentUser = getItem("user") || {};
    let userProfile = currentUser?.Profile?.profile_name;
    let navigate = useNavigate();
    const location = useLocation();
    let [sideBarData, setSideBarData] = useState([]);

    const isActive = (path) => {
        return location.pathname === path;
    };

    useEffect(() => {
        let routes = [
            {
                name: "General",
                children: [
                    { name: "Personal Settings", route_path: "settings/personal-settings" },
                    { name: "Users", route_path: "settings/users" },
                    { name: "Company Settings", route_path: "settings/company-settings" }
                ]
            },
            {
                name: "Security Control",
                children: [
                    { name: "Profiles", route_path: "settings/profiles" },
                    { name: "Roles and Sharing", route_path: "settings/roles-and-sharing" },
                    { name: "Login History", route_path: "settings/login-history" },
                    { name: "Audit Log", route_path: "settings/audit-log" },
                    { name: "Territory Management", route_path: "settings/territories" }
                ]
            },
            {
                name: "Channels",
                children: [
                    { name: "Email", route_path: "settings/email" },
                    { name: "Business Messaging", route_path: "settings/business-messaging" },
                    { name: "Notification SMS", route_path: "settings/notification-sms" }
                ]
            },
            {
                name: "Customization",
                children: [
                    { name: "Modules and Fields", route_path: "form-module" }
                ]
            },
            { name: "Automation", children: [{ name: "Workflow Rules", route_path: "workflow-rules" }] },
            { name: "Project Management" },
            { name: "Experience Center" },
            { name: "Data Administration" },
            { name: "Marketplace" },
            { name: "Developer Hub", children: [{ name: "Connections", route_path: "integration-api" }] },
            { name: "Zia" },
            { name: "CPQ" }
        ];

        routes = routes.map(section => {
            if (section.name === "Security Control" && section.children) {
                return {
                    ...section,
                    children: section.children.filter(
                        (child) => {
                            if (child.name === "Profiles" && userPermissionData?.find(u => u.key === "profilesAccess")?.permision === false) return false;
                            if (child.name === "Roles and Sharing" && userPermissionData?.find(u => u.key === "rolesAndSharingAccess")?.permision === false) return false;
                            return true;
                            // child.name !== "Profiles" &&
                            // child.name !== "Roles and Sharing"
                        })
                };
            }
            return section;
        });

        routes = routes.map(x => {
            const children =
                x.children?.map(y => ({
                    ...y,
                    isActive: isActive(Utils.getNavigationUrl(y.route_path))
                })) || [];

            return {
                ...x,
                children,
                isActive: children.some(child => child.isActive)
            };
        });

        // console.log(routes);
        setSideBarData(routes);
    }, [location.pathname]);

    // useEffect(() => {
    //     let routes = [
    //         {
    //             name: "General",
    //             children: [
    //                 { name: "Personal Settings", route_path: "settings/personal-settings" },
    //                 { name: "Users", route_path: "settings/users" },
    //                 { name: "Company Settings", route_path: "settings/company-settings" }
    //             ]
    //         },
    //         {
    //             name: "Security Control",
    //             children: [
    //                 { name: "Profiles", route_path: "settings/profiles" },
    //                 { name: "Roles and Sharing", route_path: "settings/roles-and-sharing" },
    //                 { name: "Login History", route_path: "settings/login-history" },
    //                 { name: "Audit Log", route_path: "settings/audit-log" },
    //                 { name: "Territory Management", route_path: "settings/territories" }
    //             ]
    //         },
    //         {
    //             name: "Channels",
    //             children: [
    //                 { name: "Email", route_path: "settings/email" },
    //                 { name: "Business Messaging", route_path: "settings/business-messaging" },
    //                 { name: "Notification SMS", route_path: "settings/notification-sms" }
    //             ]
    //         },
    //         {
    //             name: "Customization",
    //             children: [
    //                 { name: "Modules and Fields", route_path: "form-module" }
    //             ]
    //         },
    //         {
    //             name: "Automation",
    //             children: [
    //                 { name: "Workflow Rules", route_path: "workflow-rules" }
    //             ]
    //         },
    //         {
    //             name: "Project Management"
    //         },
    //         {
    //             name: "Experience Center"
    //         },
    //         {
    //             name: "Data Administration"
    //         },
    //         {
    //             name: "Marketplace"
    //         },
    //         {
    //             name: "Developer Hub",
    //             children: [
    //                 { name: "Connections", route_path: "integration-api" }
    //             ]
    //         },
    //         {
    //             name: "Zia"
    //         },
    //         {
    //             name: "CPQ"
    //         }
    //     ].map(x => {
    //         const children = x.children?.map(y => ({
    //             ...y,
    //             isActive: isActive(Utils.getNavigationUrl(y.route_path))
    //         })) || [];

    //         return {
    //             ...x,
    //             children,
    //             isActive: children.some(child => child.isActive)
    //         };
    //     });
    //     console.log(routes);
    //     setSideBarData(routes);
    // }, [location.pathname]);

    return (
        <main className="col-lg-12 p-0">

            <div className="row g-0 setup-card">
                <div className="col-md-2">
                    <div className="card h-100 rounded-0 border-start-0 border-top-0 border-light-subtle p-0">
                        <div className="card-header h5 bg-transparent border-0 pb-2">Setup</div>
                        <div className="card-body p-0">
                            <div className="px-3">
                                <div className="search-box border rounded-2 position-relative">
                                    <button className="searchbutton bg-white" type="button">
                                        {/* <i className="fa-solid fa-magnifying-glass"></i> */}
                                        <FiSearch />
                                    </button>
                                    <input type="search" placeholder="Search" className="searchfield bg-white" />
                                </div>
                            </div>
                            <ul
                                className="list-group mt-2 px-3 list-group-flush setupbox-height overflow-y-auto" id="parentBox">
                                {sideBarData?.length > 0 && (
                                    sideBarData?.map((x, i) => (
                                        <li key={i} className="list-group-item pe-0">
                                            <button type="button"
                                                className={`btn btn-link text-decoration-none text-body p-0 d-block w-100 text-start ${x?.isActive ? 'active' : ''}`}
                                                data-bs-toggle="collapse" data-bs-target={`#collapseGeneral${i}`}
                                                aria-expanded={x?.isActive} aria-controls={`collapseGeneral${i}`}>
                                                <img className="me-1" src={triangleIcon}
                                                    alt="recent-items" width="13" height="13" />
                                                {x?.name}
                                            </button>
                                            {x?.children?.length > 0 && (
                                                <div className={`collapse ms-3 pt-3 ${x?.isActive ? "show" : ""}`} id={`collapseGeneral${i}`} data-bs-parent="#parentBox">
                                                    <div className="list-group rounded-0">
                                                        {x?.children?.map((y => (
                                                            <a key={y?.route_path} onClick={() => { setShowNav(false); navigate(Utils.getNavigationUrl(y?.route_path)) }}
                                                                className={`list-group-item list-group-item-action border-0 ps-2 rounded-1 ${y?.isActive ? 'active' : ''}`}
                                                                aria-current="true">
                                                                {y?.name}
                                                            </a>
                                                        )))}
                                                    </div>
                                                </div>
                                            )}
                                            {/* <div className="collapse ms-3 pt-3" id={`collapseGeneral${i}`}>
                                                <div className="list-group rounded-0">
                                                    <a onClick={() => navigate(Utils.getNavigationUrl(`settings/personal-settings`))}
                                                        className={`list-group-item list-group-item-action border-0 ps-2 rounded-1 ${isActive(Utils.getNavigationUrl(`settings/personal-settings`)) ? 'active' : ''}`}
                                                        aria-current="true">
                                                        Personal Settings
                                                    </a>
                                                    <a onClick={() => navigate(Utils.getNavigationUrl(`settings/users`))}
                                                        className={`list-group-item list-group-item-action border-0 ps-2 rounded-1 ${isActive('/settings/users') ? 'active' : ''}`}
                                                        aria-current="true">
                                                        Users
                                                    </a>
                                                    <a onClick={() => navigate(Utils.getNavigationUrl(`settings/company-settings`))}
                                                        className={`list-group-item list-group-item-action border-0 ps-2 rounded-1 ${isActive('/settings/company-settings') ? 'active' : ''}`}
                                                        aria-current="true">
                                                        Company Settings
                                                    </a>
                                                </div>
                                            </div> */}
                                        </li>
                                    ))
                                )}

                                {/* <li className="list-group-item pe-0">
                                    <button type="button"
                                        className="btn btn-link text-decoration-none text-body p-0 d-block w-100 text-start"
                                        data-bs-toggle="collapse" data-bs-target="#collapseSecurityControl"
                                        aria-expanded="false" aria-controls="collapseSecurityControl">
                                        <img className="me-1" src={triangleIcon}
                                            alt="recent-items" width="13" height="13" />
                                        Security Control
                                    </button>
                                    <div className="collapse ms-3 pt-3" id="collapseSecurityControl">
                                        <div className="list-group rounded-0">
                                            <a onClick={() => navigate(Utils.getNavigationUrl(`settings/profiles`))}
                                                className={`list-group-item list-group-item-action border-0 ps-2 rounded-1 ${isActive('/settings/profiles') ? 'active' : ''}`}
                                                aria-current="true">
                                                Profiles
                                            </a>
                                            <a onClick={() => navigate(Utils.getNavigationUrl(`settings/roles-and-sharing`))}
                                                className={`list-group-item list-group-item-action border-0 ps-2 rounded-1 ${isActive('/settings/roles-and-sharing') ? 'active' : ''}`}
                                                aria-current="true">
                                                Roles and Sharing
                                            </a>
                                            <a onClick={() => navigate(Utils.getNavigationUrl(`settings/login-history`))}
                                                className={`list-group-item list-group-item-action border-0 ps-2 rounded-1 ${isActive('/settings/login-history') ? 'active' : ''}`}
                                                aria-current="true">
                                                Login History
                                            </a>
                                            <a onClick={() => navigate(Utils.getNavigationUrl(`settings/audit-log`))}
                                                className={`list-group-item list-group-item-action border-0 ps-2 rounded-1 ${isActive('/settings/audit-log') ? 'active' : ''}`}
                                                aria-current="true">
                                                Audit Log
                                            </a>
                                            <a onClick={() => navigate(Utils.getNavigationUrl(`settings/territories`))}
                                                className={`list-group-item list-group-item-action border-0 ps-2 rounded-1 ${isActive('/settings/territories') ? 'active' : ''}`}
                                                aria-current="true">
                                                Territory Management
                                            </a>
                                        </div>
                                    </div>
                                </li>
                                <li className="list-group-item pe-0">
                                    <button type="button"
                                        className="btn btn-link text-decoration-none text-body p-0 d-block w-100 text-start"
                                        data-bs-toggle="collapse" data-bs-target="#collapseChannels"
                                        aria-expanded="false" aria-controls="collapseChannels">
                                        <img className="me-1" src={triangleIcon}
                                            alt="recent-items" width="13" height="13" />
                                        Channels
                                    </button>
                                    <div className="collapse ms-3 pt-3" id="collapseChannels">
                                        <div className="list-group rounded-0">
                                            <a onClick={() => navigate(Utils.getNavigationUrl(`settings/email`))}
                                                className={`list-group-item list-group-item-action border-0 ps-2 rounded-1 ${isActive('/settings/email') ? 'active' : ''}`}
                                                aria-current="true">
                                                Email
                                            </a>
                                            <a onClick={() => navigate(Utils.getNavigationUrl(`settings/business-messaging`))}
                                                className={`list-group-item list-group-item-action border-0 ps-2 rounded-1 ${isActive('/settings/business-messaging') ? 'active' : ''}`}
                                                aria-current="true">
                                                Business Messaging
                                            </a>
                                            <a onClick={() => navigate(Utils.getNavigationUrl(`settings/notification-sms`))}
                                                className={`list-group-item list-group-item-action border-0 ps-2 rounded-1 ${isActive('/settings/notification-sms') ? 'active' : ''}`}
                                                aria-current="true">
                                                Notification SMS
                                            </a>
                                        </div>
                                    </div>
                                </li>
                                <li className="list-group-item pe-0">
                                    <button type="button"
                                        className="btn btn-link text-decoration-none text-body p-0 d-block w-100 text-start"
                                        data-bs-toggle="collapse" data-bs-target="#collapseCustomization"
                                        aria-expanded="false" aria-controls="collapseCustomization">
                                        <img className="me-1" src={triangleIcon}
                                            alt="recent-items" width="13" height="13" />
                                        Customization
                                    </button>
                                    <div className="collapse ms-3 pt-3" id="collapseCustomization">
                                        <div className="list-group rounded-0">
                                            <a onClick={() => navigate(Utils.getNavigationUrl(`form-module`))}
                                                className={`list-group-item list-group-item-action border-0 ps-2 rounded-1 ${isActive('/form-module') ? 'active' : ''}`}
                                                aria-current="true">
                                                Modules and Fields
                                            </a>
                                        </div>
                                    </div>
                                </li>
                                <li className="list-group-item pe-0">
                                    <button type="button"
                                        className="btn btn-link text-decoration-none text-body p-0 d-block w-100 text-start"
                                        data-bs-toggle="collapse" data-bs-target="#collapseAutomation"
                                        aria-expanded="false" aria-controls="collapseAutomation">
                                        <img className="me-1" src={triangleIcon}
                                            alt="recent-items" width="13" height="13" />
                                        Automation
                                    </button>
                                    <div className="collapse ms-3 pt-3" id="collapseAutomation">
                                        <div className="list-group rounded-0">
                                            <a onClick={() => navigate(Utils.getNavigationUrl(`workflow-rules`))}
                                                className={`list-group-item list-group-item-action border-0 ps-2 rounded-1 ${isActive('/workflow-rules') ? 'active' : ''}`}
                                                aria-current="true">
                                                Workflow Rules
                                            </a>
                                        </div>
                                    </div>
                                </li>
                                <li className="list-group-item pe-0">
                                    <button type="button"
                                        className="btn btn-link text-decoration-none text-body p-0 d-block w-100 text-start">
                                        <img className="me-1" src={triangleIcon}
                                            alt="recent-items" width="13" height="13" />
                                        Project Management
                                    </button>
                                </li>
                                <li className="list-group-item pe-0">
                                    <button type="button"
                                        className="btn btn-link text-decoration-none text-body p-0 d-block w-100 text-start">
                                        <img className="me-1" src={triangleIcon}
                                            alt="recent-items" width="13" height="13" />
                                        Experience Center
                                    </button>
                                </li>
                                <li className="list-group-item pe-0">
                                    <button type="button"
                                        className="btn btn-link text-decoration-none text-body p-0 d-block w-100 text-start">
                                        <img className="me-1" src={triangleIcon}
                                            alt="recent-items" width="13" height="13" />
                                        Data Administration
                                    </button>
                                </li>
                                <li className="list-group-item pe-0">
                                    <button type="button"
                                        className="btn btn-link text-decoration-none text-body p-0 d-block w-100 text-start">
                                        <img className="me-1" src={triangleIcon}
                                            alt="recent-items" width="13" height="13" />
                                        Marketplace
                                    </button>
                                </li>
                                <li className="list-group-item pe-0">
                                    <button type="button"
                                        className="btn btn-link text-decoration-none text-body p-0 d-block w-100 text-start"
                                        data-bs-toggle="collapse" data-bs-target="#collapseDeveloperhub"
                                        aria-expanded="false" aria-controls="collapseDeveloperhub">
                                        <img className="me-1" src={triangleIcon}
                                            alt="recent-items" width="13" height="13" />
                                        Developer Hub
                                    </button>
                                    <div className="collapse ms-3 pt-3" id="collapseDeveloperhub">
                                        <div className="list-group rounded-0">
                                            <a onClick={() => navigate(Utils.getNavigationUrl(`integration-api`))}
                                                className={`list-group-item list-group-item-action border-0 ps-2 rounded-1 ${isActive('/integration-api') ? 'active' : ''}`}
                                                aria-current="true">
                                                Connections
                                            </a>
                                        </div>
                                    </div>
                                </li>
                                <li className="list-group-item pe-0">
                                    <button type="button"
                                        className="btn btn-link text-decoration-none text-body p-0 d-block w-100 text-start">
                                        <img className="me-1" src={triangleIcon}
                                            alt="recent-items" width="13" height="13" />
                                        Zia
                                    </button>
                                </li>
                                <li className="list-group-item pe-0">
                                    <button type="button"
                                        className="btn btn-link text-decoration-none text-body p-0 d-block w-100 text-start">
                                        <img className="me-1" src={triangleIcon}
                                            alt="recent-items" width="13" height="13" />
                                        CPQ
                                    </button>
                                </li> */}
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="col-md-10 px-0 py-0">
                    <Outlet />
                </div>
            </div>
        </main >
    )
}
export default Setup;